import { AdminTab } from '@/constants/adminTabs';
import { createContext, useContext, ReactNode } from 'react';

interface AdminNavigationContextType {
  tabs?: AdminTab[];
  activeTab?: string;
  setActiveTab?: (key: string) => void;
  isSidebarExpanded?: boolean;
  setSidebarExpanded?: (value: boolean) => void;
}

const AdminNavigationContext = createContext<AdminNavigationContextType>({});

export const useAdminNavigation = () => useContext(AdminNavigationContext);

interface AdminNavigationProviderProps {
  children: ReactNode;
  tabs?: AdminTab[];
  activeTab?: string;
  setActiveTab?: (key: string) => void;
  isSidebarExpanded?: boolean;
  setSidebarExpanded?: (value: boolean) => void;
}

export const AdminNavigationProvider = ({
  children,
  tabs,
  activeTab,
  setActiveTab,
  isSidebarExpanded,
  setSidebarExpanded,
}: AdminNavigationProviderProps) => (
  <AdminNavigationContext.Provider value={{ tabs, activeTab, setActiveTab, isSidebarExpanded, setSidebarExpanded }}>
    {children}
  </AdminNavigationContext.Provider>
);
